export enum PageFocusEventType {
    RxDetails = 1,
    PV1 = 2,
    PV2 = 3,
}

export enum PageFocusEventClosedAction {
    Completed = 1,
    Abandoned = 2,
}

export interface PageFocusEvent {
    storeID: number;
    rxNumber: number;
    rfNumber: number;
    pageType: PageFocusEventType;
    closedAction: PageFocusEventClosedAction;
    visibleDurationSeconds: number | null;
    totalDurationSeconds: number | null;
}
